import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { ValueProps } from './components/sections/ValueProps';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { SoundFamiliar } from './components/sections/SoundFamiliar';
import { Volumes } from './components/sections/Volumes';
import { SystemExtras } from './components/sections/SystemExtras';
import { Bonuses } from './components/sections/Bonuses';
import { OfferStack } from './components/sections/OfferStack';
import { WhyPay } from './components/sections/WhyPay';
import { Guarantee } from './components/sections/Guarantee';
import { AboutKarito } from './components/sections/AboutKarito';
import { Testimonials } from './components/sections/Testimonials';
import { ForYouAndFaq } from './components/sections/ForYouAndFaq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-ink-900 font-sans text-white antialiased" data-id="element-0" data-mp="3mkrcviybbdc9">
      <MetaPixel data-id="element-1" data-mp="3rcj6y3gog175" />
      <main data-id="element-2" data-mp="3rbzmaezn6ypf">
        <Hero data-id="element-3" data-mp="3rdarmj8qkein" />
        <ValueProps data-id="element-4" data-mp="3rcsw5otwe4bs" />
        <BeforeAfter data-id="element-5" data-mp="3recctgjguhe3" />
        <SoundFamiliar data-id="element-6" data-mp="5ot150vj28n" />
        <Volumes data-id="element-7" data-mp="680frswe88f" />
        <SystemExtras data-id="element-8" data-mp="4n725ibkvc5" />
        <Bonuses data-id="element-9" data-mp="82kz509bybz" />
        <OfferStack data-id="element-10" data-mp="2zl3alhpbj03q" />
        <WhyPay data-id="element-11" data-mp="2zllduyaeeel5" />
        <Guarantee data-id="element-12" data-mp="2zm4wkh7vh708" />
        <AboutKarito data-id="element-13" data-mp="2zmo5j8fjol24" />
        <Testimonials data-id="element-14" data-mp="2zng1ikd20ksx" />
        <ForYouAndFaq data-id="element-15" data-mp="33mf1rrnubte1" />
        <FinalCta data-id="element-16" data-mp="33nq6btp41567" />
      </main>
      <Footer data-id="element-17" data-mp="33myn7icp8zwt" />
      <FloatingCta data-id="element-18" data-mp="33oi337ug18y2" />
      <PurchasePopup data-id="element-19" data-mp="38m1gy6n8bjph" />
    </div>;
}